import React from "react";
import { ChevronRight } from "lucide-react";
import { CARD, DARK, INK, LINE, LINE_STRONG, TEAL } from "../styles";
import { describeForm } from "../constants";
import { formatDMY } from "../helpers";
import type { ArchivedForm } from "../types";

interface FormCardProps {
  form: ArchivedForm;
  onView: () => void;
}

export default function FormCard({ form, onView }: FormCardProps) {
  const desc = describeForm(form.form_type);
  const periodLine =
    formatDMY(form.period_start) +
    " to " +
    formatDMY(form.period_end) +
    (form.period_label ? " (" + form.period_label + ")" : "");

  return (
    <div
      onClick={onView}
      style={{
        background: CARD,
        border: "1px solid " + LINE,
        borderRadius: 12,
        padding: "18px 20px",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 18,
        marginBottom: 12,
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = TEAL;
        e.currentTarget.style.background = "#FAFBFC";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = LINE;
        e.currentTarget.style.background = CARD;
      }}
    >
      <div style={{ display: "flex", gap: 8 }}>
        <span style={{ color: DARK, marginTop: 2 }}>
          <ChevronRight size={14} strokeWidth={2.5} />
        </span>
        <div>
          <div style={{ fontWeight: 700, fontSize: 15, color: INK }}>
            {form.form_type}
          </div>
          <div
            style={{
              color: DARK,
              fontSize: 13,
              marginTop: 2,
              fontWeight: 600,
            }}
          >
            {desc}
          </div>
          <div
            style={{
              color: DARK,
              fontSize: 13,
              marginTop: 2,
              fontWeight: 600,
            }}
          >
            {periodLine}
          </div>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
        <div
          style={{
            fontWeight: 700,
            fontSize: 14,
            color: INK,
            whiteSpace: "nowrap",
          }}
        >
          Archived {formatDMY(form.archived_at)}
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onView();
          }}
          style={{
            padding: "10px 18px",
            background: "white",
            border: "1px solid " + LINE_STRONG,
            color: INK,
            fontWeight: 700,
            borderRadius: 10,
            cursor: "pointer",
            fontSize: 14,
            fontFamily: "inherit",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#F9FAFB")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
        >
          View
        </button>
      </div>
    </div>
  );
}